import { ApplicationState } from '../store'

export const selectCompanyOwnerId = (state: ApplicationState): string | null =>
  state.companyReducer.selectedCompanyOwnerId ?? null
